/**
 * @see https://virginvoyages.atlassian.net/browse/MSH-128120?focusedCommentId=1071996
 */
export const LOCK_IT_IN_FLOW_CABIN_TYPES = ['TZ', 'IZ'];
export const LOCK_IT_IN_CABIN_TYPES = [...LOCK_IT_IN_FLOW_CABIN_TYPES, 'VZ', 'RZ', 'MZ'];
